import api from '../api'

export default {
    namespaced: true,
    state: {
        productList: [],// 商品配置
        iosChannelList: {// 内购渠道列表
            beanList: [],
            total: 0
        },
        iosChannelProductList: [],// 渠道内购列表
    },
    mutations: {
        setStateProductList(state, info) {
            state.productList = info
        },
        setStateIosChannelList(state, info) {
            state.iosChannelList = info
        },
        setStateIosChannelProductList(state, info) {
            state.iosChannelProductList = info
        }
    },
    actions: {
        getProductList({commit}, channelId) {
            return api.post(`/payment/product/list/${channelId}`, '商品列表').then(res => {
                commit('setStateProductList', res.data)
            })
        },
        updateProduct(store, params) {
            return api.post(`/payment/product/edit`, '更新或者添加商品', params)
        },
        deleteProduct(store, id) {
            return api.post(`/payment/product/del/${id}`, '删除商品')
        },
        applyProduct(store, channelId) {
            return api.post(`/payment/product/apply/${channelId}`, '下发商品配置到商城系统')
        },
        getIosChannelList({commit}) {
            return api.post(`/ios/channel/list`, '内购配置列表').then(res => {
                commit('setStateIosChannelList', res.data)
            })
        },
        addIosChannel(store, params) {
            return api.post('/ios/channel/add', '内购配置新增', params)
        },
        updateIosChannel(store, params) {
            return api.post('/ios/channel/edit', '内购配置修改', params)
        },
        deleteIosChannel(store, id) {
            return api.post(`/ios/channel/del/${id}`, '内购配置==删除')
        },
        applyIosChannel(store, channelId) {
            return api.post(`/ios/channel/apply/${channelId}`, '下发商品配置到商城系统')
        },
        getIosChannelProductList({commit}, {id,...params}) {
            return api.post(`/ios/channel/product/list/${id}`, '内购马甲对应的商品列表',params).then(res => {
                commit('setStateIosChannelProductList', res.data)
            })
        },
        addIosChannelProduct(store, params) {
            return api.post('/ios/channel/product/add', '内购马甲对应的商品--添加', params)
        },
        deleteIosChannelProduct(store, id) {
            return api.post(`/ios/channel/product/del/${id}`, '内购马甲对应的商品--删除', {id})
        },
        updateIosChannelProduct(store, params) {
            return api.post('/ios/channel/product/edit', '内购马甲对应的商品--编辑', params)
        },
        getRestartCalculator(store, id){
            return api.post(`/calculatorRestart/restart/${id}`, '定时器失败发送', {id})
        },
        getRestartCalculatorList(store,params){
            return api.post(`/calculatorRestart/list`, '定时器失败的列表', params)
        }
    }
}